































import { Component, Prop } from 'vue-property-decorator';

import 'devextreme/data/odata/store';
import { default as DxDataSource } from 'devextreme/data/data_source';

import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { FetchService } from '@/core/services/fetchService';

import { Page } from '@/core/components/controls';
import {
    FetchServiceContract,
    CONTRACTS,
    AuthServiceContract,
} from '@/core/contracts';
import container from '@/container';
import { Pack } from '@/dto';
import { DataSource } from '@/types';

import { ConsumptionsPageArgs } from './types';
import ConsumptionsEditTable from './ConsumptionsEditTable.vue';

const getODataPackUrl = () =>
    container
        .get<FetchService>(CONTRACTS.FetchService)
        .buildAbsoluteUrl(`/api/odata/Packs`);

@Component({
    components: {
        ConsumptionsEditTable,
        TableOptions,
    },
})
export default class ConsumptionsEditPage extends Page {
    @Prop({ default: () => ({}) })
    public args!: ConsumptionsPageArgs;

    public table: Table | null = null;
    public tableKey: string = 'consumptions-edit-control';

    public setTable(table: Table): void {
        this.table = table;
    }

    public get dataSource(): DataSource {
        return new DxDataSource({
            store: {
                type: 'odata',
                url: getODataPackUrl(),
                version: 4,
                key: 'Id',
                beforeSend: (preReq: any) => {
                    preReq.headers.Authorization = `Bearer ${
                        container.get<AuthServiceContract>(
                            CONTRACTS.AuthService
                        ).accessToken
                    }`;
                    // OData hack
                    if (
                        preReq.params.$filter &&
                        preReq.params.$filter.indexOf(
                            'ODataModels/Consumption'
                        ) > -1
                    ) {
                        preReq.params.$filter = preReq.params.$filter.replace(
                            'ODataModels/Consumption',
                            'ODataModels.Consumption'
                        );
                    }
                },
            },
            select: [
                'Id',
                'objectCode',
                'orderNumber',
                'planCode',
                'quantity',
                'State',
            ],
            expand: ['State'],
            filter: [
                ['State', '<>', null],
                'and',
                [`isOf(State, 'ODataModels.Consumption')`],
            ],
            update: this.saveChangedOData,
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get hasChanges(): boolean {
        if (this.table) {
            return this.table!.hasEditData();
        }
        return false;
    }

    public saveChanges(): void {
        this.table!.saveEditData();
    }

    public resetChanges(): void {
        this.table!.cancelEditData();
    }

    public async saveChangedOData(key: Pack, values: Pack) {
        const url = `${getODataPackUrl()}(${key.Id})`;
        await container
            .get<FetchServiceContract>(CONTRACTS.FetchService)
            .post(url, values);
    }
}
